import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { ReactNode } from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

interface NoInfoGraphicDataProps {
  label: string;
  icon: ReactNode;
}

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px',
  },
});

const NoTabsData: React.FC<NoInfoGraphicDataProps> = ({ label, icon }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.mainContainer}>
      {icon}
      <Typography
        fontSize="12px"
        fontType="semiBold"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {label}
      </Typography>
    </Grid>
  );
};

export default NoTabsData;
